import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const AccessDenied = loadable(() => import(/* webpackChunkName: "AccessDenied" */ './AccessDenied'), {
  fallback: <LoadableFallback visible />,
});

const asyncAccessDenied = ({ route }) => (
  <AccessDenied route={route} />
);

asyncAccessDenied.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncAccessDenied;
